
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppButton, AppCard, AppDateTimePicker } from '@/components';
import { useVersionEdit } from '@/modules/version/model/edit';
import { VersionOptions } from '@/modules/version/model/mixins';
import { ROUTE_NAME_VERSION } from '@/modules/version/router';

export default defineComponent({
    name: ROUTE_NAME_VERSION.EDIT,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, update } = useVersionEdit();

        onMounted(async () => {
            await fetch();
        });

        return { model, v$, VersionOptions, update };
    }
});
